import { isLoaded } from 'src/app/shared/utils/async';

import type { PetitionDetailsPageHeadData } from './types';

function isIndexed(prefetchedData: PetitionDetailsPageHeadData): boolean {
	if (!isLoaded(prefetchedData.pageData)) return false;
	const { signatureState, discoverable } = prefetchedData.pageData.pageData.petition;
	return signatureState.signatureCount.total >= 5 && discoverable;
}

export function petitionDetailsPageCanonical({
	prefetchedData,
	pathname,
}: {
	prefetchedData: PetitionDetailsPageHeadData;
	pathname: string;
}): string | undefined {
	if (!isLoaded(prefetchedData.pageData)) {
		return undefined;
	}
	if (!isIndexed(prefetchedData)) {
		return undefined;
	}
	return pathname;
}

export { isIndexed as petitionDetailsIsIndexed };
